// Copyright (c) Docugami, Inc. All rights reserved.

import { useActivityPingQuery } from "store/frontend/frontendSlice";
import { useAppSelector } from "./redux"
import { skipToken } from "@reduxjs/toolkit/dist/query";

export const useActivityTracking = () => {
    const organizationId = useAppSelector(state => state.organizations.currentOrganization?.id);
    const docsetId = useAppSelector(state => state.reportsSlice.clusterId);

    useActivityPingQuery(!!organizationId ? docsetId : skipToken, { pollingInterval: 120_000});
}
